import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    publicToken: String,
    email: String,
  }

  connect() {
    // If Rebound is already present then do not load and configure it again
    if (window.Rebound) {
      return
    }

    this._configure()
    this._load()
  }

  disconnect() {
    // Clean up Rebound so that consecutive page loads can re-initialize it again
    window.Rebound = null
    window.ReboundSettings = null
  }

  // Load the Postmark Rebound widget
  _load() {
    let script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "https://rebound.postmarkapp.com/widget/1.0"
    script.async = true

    let parent = document.getElementsByTagName("script")[0].parentNode
    parent.appendChild(script)
  }

  // Configure Postmark Rebound using this controller's values
  _configure() {
    window.ReboundSettings = {
      publicToken: this.publicTokenValue,
      email: this.emailValue,
      appearance: "custom",
      complete: function (response) {
        if (!response.inactive) {
          return
        }

        let message = i18n.t("js.postmark.email_bounced_html", {
          email: response.data.email,
          reason: response.data.reason,
          link: "/users/change-email",
        })
        App.displayFlash("alert", message)
      },
    }
  }
}
